interface SSMConfig {
  authUiBaseUrl: string;
  domusoApiService: string;
  userPoolId: string;
  userPoolClientId: string;
  propertyService: string;
  vantivPaypageUrl: string;
  paypageId: string;
  reportGroup: string;
  moneygramFlatFee: string;
  moneygramReservationCode: string;
  docGenerationService: string;
  dCashDaysDelayed: string;
  dynamoStreamMachineService: string;
  datadog: {
    clientToken: string;
    isEnabled: boolean;
  };
  emailSupport: string;
  phoneSupport: string;
  fastlinkv4: {
    url: string;
    config: string;
  },
}

export const useConfig = () => {
  const config = require("../../config");
  return config as SSMConfig;
};
